import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { BrandLoader } from "@/components/brand/BrandLoader";

function RouteLoading() {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "grid",
        placeItems: "center",
      }}
    >
      <BrandLoader variant="route" label={t("common.loadingPage")} />
    </Box>
  );
}

function RouteTransitionLoading() {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "grid",
        placeItems: "center",
      }}
    >
      <BrandLoader
        variant="route"
        testId="route-transition-loader"
        label={t("common.loadingPage")}
      />
    </Box>
  );
}

export { RouteLoading, RouteTransitionLoading };
